<template>
    <div>
        <div class="row mt-5" id="income-statement">
            <div class="col-md-6 hidden" id="stats">
                <div id="printMe">
                    <div class="col-lg-12">
                        <h2 class="text-center mb-4">گزارش سود و زیان {{reportTitle}}</h2>
                    </div>
                    <div class="row border-bottom p-3">
                        <div class="col-6">
                            <h4 class="text-right">فروش خالص</h4>
                        </div>
                        <div class="col-6">
                            <h4 class="text-left">{{stats.salesAmount.toLocaleString()}}</h4>
                        </div>
                    </div>
                    <div class="row border-bottom p-3">
                        <div class="col-6">
                            <h4 class="text-right">خرید خالص</h4>
                        </div>
                        <div class="col-6">
                            <h4 class="text-left">{{stats.buyNetAmount.toLocaleString()}}</h4>
                        </div>
                    </div>
                    <div class="row border-bottom p-3">
                        <div class="col-6">
                            <h4 class="text-right">سود فروش کالا</h4>
                        </div>
                        <div class="col-6">
                            <h4 class="text-left">{{stats.salesBenefit.toLocaleString()}}</h4>
                        </div>
                    </div>
                    <div class="row border-bottom p-3" v-if="showAll">
                        <div class="col-6">
                            <h4 class="text-right text-danger">جمع کل هزینه ها</h4>
                        </div>
                        <div class="col-6">
                            <h4 class="text-left text-danger">{{stats.costAmount.toLocaleString()}}</h4>
                        </div>
                    </div>
                    <div class="row border-bottom p-3" v-if="showAll">
                        <div class="col-6">
                            <h4 class="text-right text-danger">جمع کل درآمد ها</h4>
                        </div>
                        <div class="col-6">
                            <h4 class="text-left text-danger">{{stats.incomeAmount.toLocaleString()}}</h4>
                        </div>
                    </div>
                    <div class="row p-3">
                        <div class="col-6">
                            <h4 class="text-right text-success">سود خالص</h4>
                        </div>
                        <div class="col-6">
                            <h4 class="text-left text-success">{{stats.benefitNetAmount.toLocaleString()}}</h4>
                        </div>
                    </div>
                    <button type="button" class="d-inline-block btn btn-success m-1" @click="onPrintClicked"><i
                            class="fa fa-print"></i></button>
                </div>
            </div>
            <div class="col-md-6">
                <div class="row center" id="datepicker">
                    <!--<div class="col-lg-12">-->
                    <!--<h2 class="text-center mb-4">گزارش سود و زیان {{reportTitle}}</h2>-->
                    <!--</div>-->
                    <div class="col-lg-12 col-md-12 col-12 d-inline-block mb-2">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">گزارش بر اساس :</span>
                            </div>
                            <vs-select :data="benefitType" :mode="'create'"
                                       :header="{multiple: false, label: 'name'}"
                                       @onChange="onSelectBenefitType"></vs-select>
                        </div>
                    </div>
                    <div class="col-lg-12 col-md-12 col-12 d-inline-block mb-2" v-if="showProv">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">تامین کننده :</span>
                            </div>
                            <vs-select :data="providers" :mode="'create'"
                                       :header="{multiple: false, label: 'outSourceName'}"
                                       @onChange="onSelectProvider"></vs-select>
                        </div>
                    </div>
                    <div class="col-lg-12 col-md-12 col-12 d-inline-block mb-2" v-if="showCat">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">دسته بندی :</span>
                            </div>
                            <vs-select :data="categories" :mode="'create'"
                                       :header="{multiple: false, label: 'name'}"
                                       @onChange="onSelectCategory"></vs-select>
                        </div>
                    </div>
                    <div class="col-lg-12 col-md-12 col-12 d-inline-block mb-2" v-if="showProd">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">محصول :</span>
                            </div>
                            <vs-select :data="products" :mode="'create'"
                                       :header="{multiple: false, label: 'productName'}"
                                       @onChange="onSelectProduct"></vs-select>
                        </div>
                    </div>
                    <div class="col-lg-6 mb-2">
                        <div class="input-group mb-2">
                            <div class="input-group-prepend" @click="toggleStartDatePicker">
                                <div class="input-group-text"><span>از</span></div>
                            </div>
                            <date-picker type="date" :auto-submit="true" format="jYYYY-jMM-jDD"
                                         @input="onStartDatePicked" ref="datePickerStart" style="flex: 1">
                                <slot>
                                    <input v-model="startDatePersian" class="form-control date-input" readonly="true"
                                           @click="toggleStartDatePicker">
                                    <button class="close reset-date" @click="resetStartDate">×</button>
                                </slot>
                            </date-picker>
                        </div>
                    </div>
                    <div class="col-lg-6 mb-2">
                        <div class="input-group mb-2">
                            <div class="input-group-prepend" @click="toggleEndDatePicker">
                                <div class="input-group-text"><span>تا</span></div>
                            </div>
                            <date-picker type="date" :auto-submit="true" format="jYYYY-jMM-jDD" @input="onEndDatePicked"
                                         ref="datePickerEnd" style="flex: 1; transform">
                                <slot>
                                    <input v-model="endDatePersian" class="form-control date-input" readonly="true"
                                           @click="toggleEndDatePicker">
                                    <button class="close reset-date" @click="resetEndDate">×</button>
                                </slot>
                            </date-picker>
                        </div>
                    </div>
                    <div class="col-lg-12 text-center mb-5 mb-md-0">
                        <button class="btn btn-primary" @click="getReport">ثبت</button>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import BaseService from "../_framework/api/BaseService";
    import DatePicker from '../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue';
    import Moment from 'moment-jalali';
    import * as $ from "jquery";
    import Utils from "../_framework/utils/Utils";
    import VsSelect from '../_framework/VsSelect.vue';
    import VueHtmlToPaper from 'vue-html-to-paper';
    import Vue from 'vue';

    export default {
        name: 'income-statement',
        components: {
            DatePicker,
            VsSelect
        },
        data() {
            return {
                products: [],
                categories: [],
                providers: [],
                model: {
                    fromDate: "",
                    toDate: ""
                },
                startDatePersian: "",
                endDatePersian: "",
                stats: {
                    salesAmount: 0,
                    buyNetAmount: 0,
                    salesBenefit: 0,
                    costAmount: 0,
                    incomeAmount: 0,
                    benefitNetAmount: 0,
                },
                queryParams: {
                    name: "",
                    showAll: false,
                    pageSize: 18000,
                    pageIndex: 0,
                },
                benefitType: [
                    {
                        name: "سود و زیان کلی",
                        id: 1
                    },
                    {
                        name: "تامین کننده(فقط درصورتی که کالا اختصاص داده باشید)",
                        id: 2
                    },
                    {
                        name: "دسته بندی",
                        id: 3
                    },
                    {
                        name: "محصول",
                        id: 4
                    },
                ],
                selectedbenefitType: 0,
                showAll: false,
                showProv: false,
                showCat: false,
                showProd: false,
                reportTitle: "",

            }
        },
        mounted() {
            const printoptions = {
                name: '_blank',
                specs: [
                    'fullscreen=yes',
                    'titlebar=yes',
                    'scrollbars=yes'
                ],
                styles: [
                    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
                    'https://unpkg.com/kidlat-css/css/kidlat.css'
                ]
            };
            Vue.use(VueHtmlToPaper, printoptions);

            new BaseService('categories').getAll().then(response => {
                this.categories = response.data;
            }).catch(error => {
                // error
                Utils.handleErrorWithNotification(error.message, this.$noty);
            });
            new BaseService('product', '/get').getList(this.queryParams).then(response => {
                // new BaseService('product?pageSize='
                //     + this.queryParams.pageSize
                //     + '&pageIndex='
                //     + this.queryParams.pageIndex
                //     + '&name='
                //     + this.queryParams.name
                //     + '&showAll='
                //     + this.queryParams.showAll).getList().then(response => {
                this.products = response.data.data;
                this.dataCount = response.data.count;
                $("#loading").hide();
            }).catch(error => {
                // error
                Utils.handleErrorWithNotification(error.data.message, this.$noty);
            });
            this.getProviders();
        },
        methods: {
            onPrintClicked() {
                this.$htmlToPaper('printMe');
            },
            getProviders() {
                this.queryParams = {
                    pageSize: 10000,
                    pageIndex: 0,
                    name: "",
                    types: 5
                };
                new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                    this.providers = response.data.data;
                    // let allPro ={
                    //     id:0,
                    //     outSourceName:"همه تامین کننده گان"
                    // };
                    // this.providers.push(allPro);
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.response.data.message, this.$noty);
                });
                this.queryParams = {
                    pageSize: 10002,
                    pageIndex: 0,
                    name: "",
                    types: 2
                };

            },
            getReport() {
                if(this.model.fromDate === ""){
                    this.$noty.error("لطفا ابتدای بازه تاریخی را انتخاب فرمائید");
                }else if(this.model.toDate === ""){
                    this.$noty.error("لطفا انتهای بازه تاریخی را انتخاب فرمائید");
                }else {
                    new BaseService('reports', '/getbenefitreport').getList(this.model).then(response => {
                        $("#datepicker").removeClass("center");
                        $("#stats").removeClass('hidden').addClass("animated fadeIn");
                        this.stats = response.data;

                        /*this.stats.salesGoodAmount = this.stats.buyBenefit - this.stats.salesBenefit;
                    this.stats.benefitAmount = this.stats.salesGoodAmount - this.stats.costAmount;*/
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.response.message, this.$noty);
                    });
                }
            },
            toggleStartDatePicker() {
                this.$refs.datePickerStart.togglePicker();
            },
            toggleEndDatePicker() {
                this.$refs.datePickerEnd.togglePicker();
            },
            onStartDatePicked(val) {
                this.model.fromDate = Moment(val, 'jYYYY-jMM-jDD').format('YYYY-MM-DD');
                this.startDatePersian = Moment(val, 'jYYYY-jMM-jDD').format('jDD jMMMM jYYYY');
            },
            onEndDatePicked(val) {
                this.model.toDate = Moment(val, 'jYYYY-jMM-jDD').format('YYYY-MM-DD');
                this.endDatePersian = Moment(val, 'jYYYY-jMM-jDD').format('jDD jMMMM jYYYY');
            },
            resetStartDate() {
                this.model.fromDate = '';
                this.startDatePersian = '';
            },
            resetEndDate() {
                this.model.toDate = '';
                this.endDatePersian = '';
            },
            onSelectCategory(val) {
                this.model.productId = 0;
                this.model.outsourceId = 0;
                if (val === null) {
                    this.model.categoryId = 0;
                } else {
                    this.model.categoryId = val.id;
                }
                this.reportTitle = "" + val.name;
                if (this.model.fromDate != "" && this.model.toDate != "") {
                    new BaseService('reports', '/getbenefitreport').getList(this.model).then(response => {
                        $("#datepicker").removeClass("center");
                        $("#stats").removeClass('hidden').addClass("animated fadeIn");
                        this.stats = response.data;
                        /*this.stats.salesGoodAmount = this.stats.buyBenefit - this.stats.salesBenefit;
                    this.stats.benefitAmount = this.stats.salesGoodAmount - this.stats.costAmount;*/
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.response.message, this.$noty);
                    });
                }

            },
            onSelectProduct(val) {
                this.model.categoryId = 0;
                this.model.outsourceId = 0;
                if (val === null) {
                    this.model.productId = 0;
                } else {
                    this.model.productId = val.id;
                }
                this.reportTitle = "" + val.productName;
                if (this.model.fromDate != "" && this.model.toDate != "") {
                    new BaseService('reports', '/getbenefitreport').getList(this.model).then(response => {
                        $("#datepicker").removeClass("center");
                        $("#stats").removeClass('hidden').addClass("animated fadeIn");
                        this.stats = response.data;
                        /*this.stats.salesGoodAmount = this.stats.buyBenefit - this.stats.salesBenefit;
                    this.stats.benefitAmount = this.stats.salesGoodAmount - this.stats.costAmount;*/
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.response.message, this.$noty);
                    });
                }

            },
            onSelectBenefitType(val) {
                if (val != null) {
                    this.selectedbenefitType = val.id;
                    switch (val.id) {
                        case 1:
                            this.showAll = true;
                            this.showProv = false;
                            this.showCat = false;
                            this.showProd = false;

                            this.model.categoryId = 0;
                            this.model.productId = 0;
                            this.model.outsourceId = 0;
                            this.reportTitle = "کلی";

                            if (this.model.fromDate != "" && this.model.toDate != "") {
                                new BaseService('reports', '/getbenefitreport').getList(this.model).then(response => {
                                    $("#datepicker").removeClass("center");
                                    $("#stats").removeClass('hidden').addClass("animated fadeIn");
                                    this.stats = response.data;
                                    /*this.stats.salesGoodAmount = this.stats.buyBenefit - this.stats.salesBenefit;
                                this.stats.benefitAmount = this.stats.salesGoodAmount - this.stats.costAmount;*/
                                }).catch(error => {
                                    Utils.handleErrorWithNotification(error.response.message, this.$noty);
                                });
                            }
                            break;
                        case 2:
                            this.showAll = false;
                            this.showProv = true;
                            this.showCat = false;
                            this.showProd = false;
                            break;
                        case 3:
                            this.showAll = false;
                            this.showProv = false;
                            this.showCat = true;
                            this.showProd = false;
                            break;
                        case 4:
                            this.showAll = false;
                            this.showProv = false;
                            this.showCat = false;
                            this.showProd = true;
                            break;
                    }
                }
            },
            onSelectProvider(val) {
                this.model.categoryId = 0;
                this.model.productId = 0;
                if (val === null) {
                    this.model.outsourceId = 0;
                    ``
                } else {
                    this.model.outsourceId = val.id;
                }
                this.reportTitle = "" + val.outSourceName;
                if (this.model.fromDate != "" && this.model.toDate != "") {
                    new BaseService('reports', '/getbenefitreport').getList(this.model).then(response => {
                        $("#datepicker").removeClass("center");
                        $("#stats").removeClass('hidden').addClass("animated fadeIn");
                        this.stats = response.data;
                        /*this.stats.salesGoodAmount = this.stats.buyBenefit - this.stats.salesBenefit;
                    this.stats.benefitAmount = this.stats.salesGoodAmount - this.stats.costAmount;*/
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.response.message, this.$noty);
                    });
                }

            },
        }
    }
</script>

<style>
    .hidden {
        opacity: 0;
    }

    #datepicker {
        transition: all 0.7s;
        transition-timing-function: cubic-bezier(0.79, 0.01, 0.26, 0.98);
    }

    #stats {
        transition: all 0.7s;
        transition-delay: 0.3s;
    }

    .center {
        transform: translateX(0) translateY(-50vh);
    }

    @media (min-width: 768px) {
        .center {
            transform: translateX(50%) translateY(25vh);
        }

        .vpd-wrapper {
            background-color: transparent;
        }
    }


</style>